import { useIsomorphicLayoutEffect, useLockedBody } from "usehooks-ts";
import { useIsMobile } from "@/hooks/useDisplay";
import useScrollbarSize from "react-scrollbar-size";
import { useRef } from "react";

export const cleanUpLockScroll = (isMobile?: boolean) => {
  document.body.style.removeProperty("padding-right");
  document.body.style.removeProperty("width");
  document.body.style.removeProperty("box-sizing");

  if (isMobile) {
    const scrollY = document.body.style.top;
    document.body.style.removeProperty("position");
    document.body.style.removeProperty("top");
    window.scrollTo(0, parseInt(scrollY || "0") * -1);
  }
};

const useLockScroll = (shouldLock: boolean) => {
  const [_, setLocked] = useLockedBody(false);
  const isMobile = useIsMobile();
  const { width } = useScrollbarSize();
  // to preserve scroll position when navigating back
  const scrollPosition = useRef(0);

  useIsomorphicLayoutEffect(() => {
    setLocked(shouldLock);
  }, [shouldLock, setLocked]);

  useIsomorphicLayoutEffect(() => {
    const body = document.body;

    // fix body on mobile
    if (shouldLock) {
      scrollPosition.current = window.scrollY;
      body.style.setProperty("padding-right", `${width}px`);
      body.style.setProperty("width", "100%");
      body.style.setProperty("box-sizing", "border-box");

      if (isMobile) {
        body.style.setProperty("position", "fixed");
        body.style.setProperty("top", `-${scrollPosition.current}px`);
      }
    } else {
      cleanUpLockScroll(isMobile);
    }
  }, [shouldLock, isMobile, width]);
};

export default useLockScroll;
